import { render, staticRenderFns } from "./BaseVennDiagram.vue?vue&type=template&id=01490816&scoped=true"
import script from "./BaseVennDiagram.vue?vue&type=script&lang=js"
export * from "./BaseVennDiagram.vue?vue&type=script&lang=js"
import style0 from "./BaseVennDiagram.vue?vue&type=style&index=0&id=01490816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01490816",
  null
  
)

export default component.exports